import { getUserLocation } from '../../../utils/location/locationHelper';
import { DeliveryLocation } from '../localisation/utils/types';

export const useLocationSearch = (onLocationSelect: ((value: DeliveryLocation) => void) | undefined) => {
  const fetchAndSelectUserLocation = async () => {
    const result: Array<DeliveryLocation> = await getUserLocation();
    if (result.length > 0) {
      onLocationSelect && onLocationSelect(result[0]);
      return result[0];
    }
  };

  return { fetchAndSelectUserLocation };
};
